import request from '@/utils/request' //引入封装好的 axios 请求

export function getViewList(startTime, endTime) { //查询新闻列表接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/viewed/getViewedList',
    method: 'post',
    data: { //提交的数据（用别的的字段暂存)
      month:startTime,
      viewedDate:endTime
    }
  })
}


export function getViewedData(year) { //查询新闻列表接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/viewed/getViewedData',
    method: 'post',
    data: {
      yearName:year
    }
  })
}